import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client/index.js';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { CustomerUserListAliases, FragmentNames } from '../../codegen';
import { CustomerUserRoutesApplication } from '../../constants';

@Controller({ fragment: FragmentNames.CUSTOMER_USER_LIST })
class CustomerUserListController {

  @OnClick(CustomerUserListAliases.ACTION_NEW_USER)
  onClickNew(): void {
    this.openItem('new');
  }

  openItem = (id: string): void => {
    applicationContext.redirect(CustomerUserRoutesApplication.CUSTOMER_USER_ITEM, { id });
  };

}

export default CustomerUserListController;
